import { CCard, CContainer } from "@coreui/react";

const RightSidebar = ({ isOpen, children }) => {
  return isOpen ? (
    <CContainer className="col-4 pt-0 ms-0">{children}</CContainer>
  ) : null;
};

export default RightSidebar;
